import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { brown, orange, useEnglishPage } from './enCommon';

/* 영문 차량 안내 (/en/bus). 사진은 한국어 버스안내와 같은 파일. 글을 고치면 prerender 의 EN_BUS 도 */
export const EN_BUS_TITLE = 'Our Buses — 25, 28 and 45-seat Coaches | EK Hana Tour';
export const EN_BUS_DESC =
  'Charter bus fleet in Korea: 45-seat large coach, 28-seat limousine coach and 25-seat mini bus, all with a professional driver.';

const BUSES = [
  {
    id: 'bus45', title: '45-seater large coach', exterior: '/image/bigBusExterior.jpg?v=2',
    text: 'The most common charter bus in Korea. Best for groups of 30–45 people — company outings, school and university trips, clubs and tour groups.',
    interior: ['/image/bigBus/interior1.jpg?v=2', '/image/bigBus/interior2.jpg?v=2', '/image/bigBus/interior3.jpg?v=2', '/image/bigBus/interior4.jpg?v=2'],
  },
  {
    id: 'bus28', title: '28-seater limousine coach', exterior: '/image/limousineExterior.jpg?v=3',
    text: 'A premium large coach with comfortable seats and upgraded facilities, for groups of 24–28 people. Popular for golf groups, VIP guests, companies and long-distance trips.',
    interior: ['/image/limousine/interior1.jpg?v=2', '/image/limousine/interior2.jpg?v=2', '/image/limousine/interior3.jpg?v=2', '/image/limousine/interior4.jpg?v=2'],
  },
  {
    id: 'bus25', title: '25-seater mini bus', exterior: '/image/smallBusExterior.jpg?v=2',
    text: 'For small groups, clubs, churches and schools. Easy to move around anywhere and the most economical option for small group trips.',
    interior: ['/image/smallBus/interior1.jpg?v=2', '/image/smallBus/interior2.jpg?v=2', '/image/smallBus/interior3.jpg?v=2'],
  },
];

export default function EnBus() {
  useEnglishPage(EN_BUS_TITLE, EN_BUS_DESC);

  return (
    <Box component='main' lang='en' sx={{ maxWidth: 1000, mx: 'auto', px: { xs: 2, md: 3 }, py: { xs: 3, md: 5 } }}>
      <Typography component='h1' sx={{ fontSize: { xs: 24, md: 34 }, fontWeight: 800, color: brown, textAlign: 'center' }}>
        Our buses
      </Typography>
      <Typography sx={{ mt: 1, textAlign: 'center', color: brown }}>
        Every charter comes with a professional driver. Not sure which size you need? Tell us your group size and we will suggest one.
      </Typography>

      {BUSES.map((b) => (
        <Box component='section' id={b.id} key={b.id} sx={{ mt: { xs: 4, md: 6 } }}>
          <Typography component='h2' sx={{ fontSize: { xs: 20, md: 26 }, fontWeight: 800, color: brown, borderBottom: `3px solid ${orange}`, pb: 0.5 }}>
            {b.title}
          </Typography>
          <Typography sx={{ mt: 1.5, color: brown, lineHeight: 1.7 }}>{b.text}</Typography>
          <Box component='img' src={b.exterior} alt={`${b.title} exterior`} loading='lazy'
            sx={{ mt: 2, width: '100%', borderRadius: 2, display: 'block' }} />
          <Box sx={{ mt: 1.5, display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 }}>
            {b.interior.map((src, i) => (
              <Box component='img' key={src} src={src} alt={`${b.title} interior ${i + 1}`} loading='lazy'
                sx={{ width: '100%', aspectRatio: '4 / 3', objectFit: 'cover', borderRadius: 1.5, display: 'block' }} />
            ))}
          </Box>
        </Box>
      ))}

      <Box sx={{ mt: 6, textAlign: 'center' }}>
        <Button component={RouterLink} to='/en/center' variant='contained'
          sx={{ px: 4, py: 1.2, fontWeight: 800, bgcolor: orange, '&:hover': { bgcolor: '#d98a30' } }}>
          Get a quote by email
        </Button>
      </Box>
    </Box>
  );
}
